import { TranscribeMode } from '@heidi/schema/ml-scribe';

export const isTranscribeLikeMode = (mode: TranscribeMode | null | undefined): boolean =>
  mode === TranscribeMode.TRANSCRIBE || mode === TranscribeMode.TELEHEALTH;

export const toRecordableMode = (
  mode: TranscribeMode | null | undefined
): TranscribeMode | null | undefined =>
  mode === TranscribeMode.TELEHEALTH ? TranscribeMode.TRANSCRIBE : mode;
